import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import AppLayout from '../../components/layout/AppLayout';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validate({ nombre, email, password, confirmPassword }) {
  if (!nombre.trim() || !email.trim() || !password || !confirmPassword) {
    return 'Completa todos los campos.';
  }
  if (!EMAIL_REGEX.test(email.trim())) {
    return 'Ingresa un correo electrónico válido.';
  }
  if (password.length < 8) {
    return 'La contraseña debe tener al menos 8 caracteres.';
  }
  if (password !== confirmPassword) {
    return 'Las contraseñas no coinciden.';
  }
  return '';
}

function RegistroPage() {
  const { signUp } = useAuth();
  const navigate = useNavigate();

  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState('');
  const [infoMessage, setInfoMessage] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormError('');
    setInfoMessage('');

    const validationError = validate({ nombre, email, password, confirmPassword });
    if (validationError) {
      setFormError(validationError);
      return;
    }

    setSubmitting(true);
    const result = await signUp({
      nombre: nombre.trim(),
      email: email.trim(),
      password,
    });
    setSubmitting(false);

    if (!result.ok) {
      setFormError(result.message);
      return;
    }

    if (result.needsEmailConfirmation) {
      setInfoMessage('Cuenta creada. Revisa tu correo electrónico para confirmar tu cuenta antes de iniciar sesión.');
      return;
    }

    navigate('/');
  };

  return (
    <AppLayout>
      <div className="flex flex-col gap-8">
        <header className="pt-8 text-center">
          <h1 className="text-2xl font-bold text-gray-900">Crear cuenta</h1>
          <p className="mt-1 text-sm text-gray-500">Registro de encargado de campo</p>
        </header>

        <p className="rounded-lg bg-gray-50 px-4 py-3 text-center text-sm text-gray-600">
          Después de registrarte, un administrador deberá aprobar tu acceso y asignarte un productor.
        </p>

        <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          <form className="flex flex-col gap-4" onSubmit={handleSubmit} noValidate>
            <Input
              id="nombre"
              label="Nombre completo"
              type="text"
              placeholder="Juan Pérez"
              value={nombre}
              onChange={(event) => setNombre(event.target.value)}
              autoComplete="name"
            />
            <Input
              id="email"
              label="Correo electrónico"
              type="email"
              placeholder="nombre@correo.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
            />
            <Input
              id="password"
              label="Contraseña"
              type="password"
              placeholder="Mínimo 8 caracteres"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="new-password"
            />
            <Input
              id="confirmPassword"
              label="Confirmar contraseña"
              type="password"
              placeholder="••••••••"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              autoComplete="new-password"
            />

            {formError && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{formError}</p>}
            {infoMessage && <p className="rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700">{infoMessage}</p>}

            <Button type="submit" className="mt-2" disabled={submitting}>
              {submitting ? 'Creando cuenta...' : 'Crear cuenta'}
            </Button>
          </form>

          <div className="mt-4 text-center text-sm">
            <Link to="/login" className="font-medium text-green-700 hover:underline">
              Ya tengo cuenta, iniciar sesión
            </Link>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}

export default RegistroPage;
